export function calculaReducao(valor: number, reducao: number) {
  // eslint-disable-next-line prettier/prettier
  const baseCalculo = valor - (valor * (reducao / 100));
  return parseFloat(baseCalculo.toFixed(2));
}
